module.exports = __webpack_public_path__ + "img/logo8.aaf602dc.png";